;
( function( $, window, document, undefined ) {

	"use strict";

		var pluginName = "signup",
			defaults = {
                mode: "create",
                path: "/shopify/newsletter.js",
                callback:"nullCallBack"
			};

		function Plugin ( element, options ) {
			this.element = element;

			this.settings = $.extend( {}, defaults, options );
			this._defaults = defaults;
			this._name = pluginName;
			this.init();
		}

		$.extend( Plugin.prototype, {
			init: function() {
                var data = $(this.element).serialize();
                console.log(data)
				this.send(data);
			},
			send: function( text ) {
                var url = "https://"+OsGlobals.contactDomain+this.settings.path+"?mode="+this.settings.mode+"&"+text+"&callback="+this.settings.callback;
                console.log(url);
                this.injectScript(url);
            },
            injectScript: function(url) {
                return new Promise((resolve, reject) => {
                    let src = url;
    
                    let loadScript = document.createElement('script');
    
                    loadScript.onload  = resolve;
                    loadScript.onerror = reject;
    
                    loadScript.async = true;
                    loadScript.src = src;
                    document.getElementsByTagName('head')[0].appendChild( loadScript );
                });
            }

		} );
        //*
		$.fn[ pluginName ] = function( options ) {
			return this.each( function() {
				if ( !$.data( this, "plugin_" + pluginName ) ) {
					$.data( this, "plugin_" +
						pluginName, new Plugin( this, options ) );
				}
			} );
        };
        //*/

} )( jQuery, window, document );

function nullCallBack(data) {
    return false;
}